import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '@paypalcorp/pp-react';
import { localsMessages } from '../utility/getTemplateData';
import OfferDetail from './offerDetail';
import OfferSaveButton from './offerSaveButton';

const messages = localsMessages('confirmation/confirmation');

class OfferConfirmation extends React.Component {
	createMarkup(content) {
		return {
			__html: content,
		};
	}
	render() {
		const { offerProgram } = this.props;
		return (
			<div>
				<div className="ppvx_row">
					<div className="ppvx_col-12 text-center">
						<Text
							size="md"
							style={{
								textAlign: 'center',
							}}
							dangerouslySetInnerHTML={{ __html: messages.label.offer }}
						>
						</Text>
					</div>
				</div>
				<OfferDetail offerProgram={offerProgram} />
				<OfferSaveButton
					offerProgram={offerProgram}
					txnStatement={this.props.txnId}
				/>
			</div>
		);
	}
}

OfferConfirmation.propTypes = {
	offerProgram: PropTypes.object.isRequired,
	txnId: PropTypes.string
};

export default OfferConfirmation;
